import React, { useEffect, useState } from "react";
import "./GarmentScan.css";
import { Button } from "@fluentui/react-components";
import scanImg from "../../images/scanning.png";
import profileImg from "../../images/profile-user.png";
import ScanModal from "./modal/ScanModal";
import { useNavigate } from "react-router-dom";

//console.log(process.env);
const endpoint = process.env.REACT_APP_VISION_ENDPOINT;
const key = process.env.REACT_APP_VISION_KEY;
if (!endpoint || !key) {
  console.error(
    "Environment variables REACT_APP_VISION_ENDPOINT and REACT_APP_VISION_KEY must be set."
  );
}

const features = ["Caption"];

const ImageAnalyzer = () => {
  const [scanResult, setScanResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const handleModalClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const nav = useNavigate();

  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleClick = () => {
    document.getElementById("fileInput").click();
  };

  const handleSubmit = () => {
    console.log(selectedFile);
    //const fileInput = document.querySelector("#fileInput");
    setScanResult(
      <ScanModal imageData={selectedFile} setShowModal={setShowModal} />
    );
    handleShow();
  };

  return (
    <div className="App">
      {showModal ? scanResult : <></>}
      <div className="container">
        <div className="header">
          <span className="back-arrow">←</span>
          <img src={profileImg} alt="" className="profile-icon" />
        </div>

        <h2>Scan your item</h2>
        <div style={{ border: "solid 0.5px gray", borderRadius: 5 + "px" }}>
          <div className="scanner">
            <input
              type="file"
              id="fileInput"
              accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            {selectedFile ? (
              <img
                src={URL.createObjectURL(selectedFile)}
                alt="Scanned"
                className="uploaded-image"
              />
            ) : (
              <div className="placeholder" onClick={handleClick}>
                📷
              </div>
            )}
          </div>
          <hr></hr>
          <div className="button-container">
            <Button className="scan-button" onClick={handleClick}>
              <img
                src={scanImg}
                alt=""
                style={{
                  position: "absolute",
                  top: "auto",
                  right: "75%",
                  maxWidth: "27px",
                }}
              />
              Scan
            </Button>
            <Button
              className="scan-button"
              onClick={handleSubmit}
              disabled={!selectedFile}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageAnalyzer;
